// src/app/pricing/pricing.module.ts
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '@shared/shared.module';
import { HandPricingCPRandNGPComponent } from './components/hand-pricing-cpr-ngp-modal/hand-pricing-cpr-ngp-modal.component';
import { HandPricingPopoverComponent } from './components/hand-pricing-popover/hand-pricing-popover.component';
import { PmeListFilterButtonsComponent } from './components/pme-list-filter-buttons/pme-list-filter-buttons.component';
import { PriceDisplayComponent } from './components/price-display/price-display.component';
import { ProductShippingPriceComponent } from './components/product-shipping-price/product-shipping-price.component';
import { UsfPmeToggleComponent } from './components/usf-pme-toggle/usf-pme-toggle.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    MatRadioModule,
  ],
  declarations: [
    UsfPmeToggleComponent,
    PmeListFilterButtonsComponent,
    HandPricingPopoverComponent,
    HandPricingCPRandNGPComponent,
    PriceDisplayComponent,
    ProductShippingPriceComponent,
  ],
  exports: [
    UsfPmeToggleComponent,
    PmeListFilterButtonsComponent,
    HandPricingPopoverComponent,
    HandPricingCPRandNGPComponent,
    PriceDisplayComponent,
    ProductShippingPriceComponent,
  ],
})
export class PricingModule {}
